import { render, staticRenderFns } from "./NotMainAccountModal.vue?vue&type=template&id=26030f56"
import script from "./NotMainAccountModal.vue?vue&type=script&lang=js"
export * from "./NotMainAccountModal.vue?vue&type=script&lang=js"
import style0 from "./NotMainAccountModal.vue?vue&type=style&index=0&id=26030f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports